import { render, staticRenderFns } from "./AboutMentoring.vue?vue&type=template&id=2380d762&scoped=true"
import script from "./AboutMentoring.vue?vue&type=script&lang=js"
export * from "./AboutMentoring.vue?vue&type=script&lang=js"
import style0 from "./AboutMentoring.vue?vue&type=style&index=0&id=2380d762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2380d762",
  null
  
)

export default component.exports